// import React from 'react';

const useTitle = (title) => {
    document.title = title;
};

export default useTitle;